import {
  aMatchListItem,
  aMatchListItemPage,
  anItemMeta,
  mockMatchListItemsOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

const EXPIRATION_DATE = new Date().setFullYear(new Date().getFullYear() + 1);

export const MATCH_LIST_ITEM_DATA = {
  value: 'test match list item value',
  description: 'Test match list item description',
  expiration: new Date(EXPIRATION_DATE).toISOString(),
  updatedDescription: 'Test match list item description updated',
};

export const matchListItemsHandler = ({
  id,
  value,
  expiration,
  description,
}) => ({
  data: {
    __typename: 'Query',
    matchListItems: aMatchListItemPage({
      hasNextPage: false,
      objects: [
        aMatchListItem({
          id,
          value,
          expiration,
          meta: anItemMeta({
            description,
          }),
        }),
      ],
      total: 1,
    }),
  },
});

export const handlers = [
  mockMatchListItemsOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          matchListItems: aMatchListItemPage({
            hasNextPage: false,
            objects: [],
            total: 0,
          }),
        },
      });
    }
  ),
];
